class ProfessionalRequest {
  static create = {
    professionalCustomerId: null,
    professionalOfficialEmail: null,
    professionalLinkedinLink: null,
    professionalExperienceLength: null,
    professionalExperienceLevel: null,
    professionalIndustry: null,
    professionalCategory: null,
    professionalSubCategory: null,
    professionalEducation: null,
    professionalSummary: null,
    professionalBookingFee: null,
    professionalStatus: null,
    weeklySubscriptionAmount: null,
    monthlySubscriptionAmount: null
  };

  static update = {
    professionalId: null,
    professionalCustomerId: null,
    professionalOfficialEmail: null,
    professionalLinkedinLink: null,
    professionalFollowers: null,
    professionalRating: null,
    professionalExperienceLength: null,
    professionalExperienceLevel: null,
    professionalIndustry: null,
    professionalCategory: null,
    professionalSubCategory: null,
    professionalStatus: null,
    professionalSummary: null,
    professionalBookingFee: null,
    professionalReference: null,
    customerId: null,
    customerName: null,
    customerDisplayPicture: null,
    customerCoverPhoto: null,
    customerGender: null,
    customerCountry: null,
    customerEmail: null,
    customerDOB: null,
    customerAbout: null,
    customerInterest: null,
    customerTimezone: null,
    customerWalletId: null,
    customerPayOutAccountId: null,
    customerPhoneNumber: null,
    customerCreatedAt: null,
    customerUpdatedAt: null,
    customerStatus: null
  };

  static read = {};

  static readBy = {
    professionalId: null
  };

  static search = {
    type: null,
    stringToFind: null,
    country: null,
    level: null,
    expertise: null,
    page: 1
  };

  static readReference = {
    professionalReference: null
  };

  static readSubscriptionPlans = {
    subscriptionPlanProfessionalId: null
  };
  static updateSubscriptionPlans = {
    subscriptionPlanProfessionalId: null,
    weeklySubscriptionAmount: null,
    monthlySubscriptionAmount: null
  };
}

export default ProfessionalRequest;
